import { RefObject } from 'react';

const getScrollOffset = () => {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.scrollY ?? window.pageYOffset ?? 0;
};

export const scrollToElement = (elementRef: RefObject<HTMLElement>) => {
  const target = elementRef.current;

  if (!target) {
    return;
  }

  const top = target.getBoundingClientRect().top + getScrollOffset() - 20;

  window.scrollTo({ top, behavior: 'smooth' });
};
